/* unplugin-vue-components disabled */import script from "./slideHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./slideHeader.vue?vue&type=script&lang=ts&setup=true"

import "./slideHeader.vue?vue&type=style&index=0&id=7f175c08&lang=scss&scoped=true"

import exportComponent from "/nerv.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f175c08"]])

export default __exports__